import { render, staticRenderFns } from "./InspectionViewInspection.vue?vue&type=template&id=10d40319"
import script from "./InspectionViewInspection.vue?vue&type=script&lang=js"
export * from "./InspectionViewInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports